import classNames from 'classnames';
import * as React from 'react';
import { UserContext } from '../../../contexts/UserContext';
import css from './BaseLayout.module.scss';
import MerchantGlobalFooter, {
  Props as FooterProps,
} from './MerchantGlobalFooter';

export interface Props extends React.HTMLProps<{}> {
  footerProps?: FooterProps;
}

const BaseLayoutMerchantOnlyFooter = (props: Props) => {
  const userCtx = React.useContext(UserContext);
  return (
    <div className={classNames(css.BaseLayout, props.className)}>
      {props.children}
      {!userCtx.request.isCoubicApp && (
        <div className={css.BaseLayout__Footer}>
          <MerchantGlobalFooter {...props.footerProps} />
        </div>
      )}
    </div>
  );
};

export default BaseLayoutMerchantOnlyFooter;
